<template>
  <div>
    <form-field-editor
      ref="noteField"
      placeholder="write your note here..."
      v-model="note.body"
      type="note"
    ></form-field-editor>

    <div class="flex flex-vertical-center flex-end">
      <div class="flex">
        <button-link
          @click="clearNote"
          tabindex="-1"
        >clear</button-link>

        <button-default
          class="ml-100"
          :loading="isPosting"
          :disabled="isPosting || note.body === ''"
          @click="addNote"
        >Save Note</button-default>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "CommNote",
  props: {
    noteable: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      isPosting: false,
      validationErrors: {},
      note: {
        type: this.type,
        noteable_id: this.noteable.id,
        noteable_type: this.noteable.class_name,
        body: '',
      },
    }
  },
  methods: {
    addNote() {
      if (this.note.body) {
        this.isPosting = true;

        this.$api.notes.create(this.note, this.validationErrors)
          .then(() => {
            this.clearNote()
            this.$buefy.toast.open({
              message: 'Lead Note has been created',
              type: 'is-success'
            });
          })
          .finally(() => this.isPosting = false);
      }
    },
    clearNote() {
      this.$refs.noteField.clear();
    }
  }
}
</script>
